module.exports = {
    appName: '网格化', //名称
    theme: '#386d9f', //APP主题颜色
    themeTintColor: '#fff', //tint color
    showNavBar: false, //是否显示导航栏
}



// WEBPACK FOOTER //
// ./src/components/Config.js